const {
    useCallback,
    useEffect,
    useMemo,
    useState
} = require('react');

exports.useChatMentions = function useChatMentions({ sid, users }) {

    const [searchedUsers, setSearchedUsers] = useState([]);

    useEffect(() => {

        setSearchedUsers([]);
    }, [sid]);

    const updateMentionUsers = useCallback((searchUsers) => {

        setSearchedUsers((currentUsers) => currentUsers.concat(searchUsers));
    }, []);

    const mentionUsers = useMemo(() => {

        const combinedUsers = users.concat(searchedUsers);

        return [...new Map(combinedUsers.map((item) => [item.id, item])).values()];
    }, [searchedUsers, users]);

    return {
        mentionUsers,
        updateMentionUsers
    };
};
